import { computed, watch } from "vue";
// import { useTeamEditionStore } from "@/store/teamEdition";
import { useSystemTimeStore } from "@/store/systemTime";
import { objExt } from "@xmiles/holopix-helper";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { ACTIVITY_TIME_CONFIG } from "@/constants/activityTime";
import {
  getActivity618DebugRemainingSeconds,
  isActivity618DebugEnabled
} from "@/utils/activity618Debug";

// 扩展 dayjs 插件
dayjs.extend(utc);
dayjs.extend(timezone);

/** @deprecated 请从 `@/constants/activityTime` 导入，此处保留兼容 re-export */
export { ACTIVITY_TIME_CONFIG } from "@/constants/activityTime";

export function useActivityCheck() {
  // const teamEditionStore = useTeamEditionStore();
  const systemTimeStore = useSystemTimeStore(); 

  // 转换为时间戳进行对比
  const defaultRange = [
    dayjs.tz(ACTIVITY_TIME_CONFIG.start, "Asia/Shanghai").valueOf(),
    dayjs.tz(ACTIVITY_TIME_CONFIG.end, "Asia/Shanghai").valueOf()
  ];

  const raw = localStorage.getItem("activityDateMs");

  let activityDateMs: number[] = defaultRange;
  try {
    const parsed = raw ? objExt.parse<number[]>(raw) : null;
    if (Array.isArray(parsed) && parsed.length >= 2) {
      const a = Number(parsed[0]);
      const b = Number(parsed[1]);
      if (Number.isFinite(a) && Number.isFinite(b)) activityDateMs = [a, b];
    }
  } catch (e) {
    console.error("解析活动时间配置失败", e);
  }

  const ACTIVITY_PERIOD = {
    start: Number(activityDateMs[0]),
    end: Number(activityDateMs[1])
  };

  const normalizeMs = (t: number) => (t && t < 1e12 ? t * 1000 : t);
  const serverTimestampMs = computed(() => normalizeMs(systemTimeStore.timestamp));
  const serverDate = computed(() => (serverTimestampMs.value ? new Date(serverTimestampMs.value) : null));

  const isActive = computed(() => {
    if (isActivity618DebugEnabled()) return true;
    if (!serverTimestampMs.value) return false;
    if (!Number.isFinite(ACTIVITY_PERIOD.start) || !Number.isFinite(ACTIVITY_PERIOD.end)) return false;
    return serverTimestampMs.value >= ACTIVITY_PERIOD.start && serverTimestampMs.value <= ACTIVITY_PERIOD.end;
  });

  const remainingSeconds = computed(() => {
    if (isActivity618DebugEnabled()) {
      return getActivity618DebugRemainingSeconds(serverTimestampMs.value);
    }
    if (!serverTimestampMs.value) return 0;
    if (!Number.isFinite(ACTIVITY_PERIOD.start) || !Number.isFinite(ACTIVITY_PERIOD.end)) return 0;
    if (serverTimestampMs.value < ACTIVITY_PERIOD.start) return 0;
    if (serverTimestampMs.value > ACTIVITY_PERIOD.end) return 0;
    const remainingMs = ACTIVITY_PERIOD.end - serverTimestampMs.value;
    return Math.max(0, Math.floor(remainingMs / 1000));
  });

  const states = {
    isLoading: computed(() => systemTimeStore.timestamp === 0),
    serverDate,
    isActive,
    error: computed(() => null),
    remainingSeconds
  };

  async function refresh() {
    await systemTimeStore.getServerTime();
  }

  systemTimeStore.getServerTime();

  // watch(
  //   isActive,
  //   (active) => {
  //     teamEditionStore.isShow618Activity = active;
  //   },
  //   { immediate: true }
  // );

  return {
    ...states,
    refresh
  };
}
